import { render, staticRenderFns } from "./noCause.vue?vue&type=template&id=6c04df30&scoped=true"
import script from "./noCause.vue?vue&type=script&lang=js"
export * from "./noCause.vue?vue&type=script&lang=js"
import style0 from "./noCause.vue?vue&type=style&index=0&id=6c04df30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04df30",
  null
  
)

export default component.exports